/* Accessory carousel (product page) and cart drawer "Interesse?" block: variant price + add to cart.
   Uses document-level delegation, so it keeps working when the cart drawer is re-rendered. No dependencies. */
(function () {
  'use strict';
  if (window.__woweUpsell) return;
  window.__woweUpsell = true;

  function updateCartCount(count) {
    var text = count > 99 && window.cartStrings && window.cartStrings.item_99 ? window.cartStrings.item_99 : String(count);
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = text; });
  }

  function setPrice(card, option) {
    var box = card.querySelector('[data-upsell-price]');
    if (!box || !option) return;
    var compare = option.getAttribute('data-compare');
    var nowEl = box.querySelector('.wowe-upsell__now');
    var nowCls = nowEl ? nowEl.className : 'wowe-upsell__now';
    var html = '';
    if (compare) html += '<s class="wowe-upsell__compare">' + compare + '</s> ';
    html += '<span class="' + nowCls + '">' + option.getAttribute('data-price') + '</span>';
    box.innerHTML = html;
  }

  // Refresh (and optionally open) the theme cart drawer after an add.
  function syncDrawer(cart, open) {
    var drawer = document.getElementById('halo-cart-sidebar');
    var fns = window.sharedFunctions;
    if (!drawer || !fns || typeof fns.updateSidebarCart !== 'function' || !(window.quick_cart && window.quick_cart.show)) return false;
    fns.updateSidebarCart(cart);
    if (open) document.body.classList.add('cart-sidebar-show');
    return true;
  }

  // Phones: the discount code field is collapsed behind a toggle button.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-coupon-toggle]');
    if (!t) return;
    var box = t.closest('.wowe-coupon-inline');
    var open = box.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var input = box.querySelector('input[name="discount"]'); if (input) input.focus(); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-upsell-variant]');
    if (!sel || !sel.closest('[data-wowe-upsell]')) return;
    setPrice(sel.closest('[data-upsell-card]'), sel.options[sel.selectedIndex]);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    var root = btn.closest('[data-wowe-upsell]');
    if (!root) return;
    var card = btn.closest('[data-upsell-card]');
    var field = card.querySelector('[data-upsell-variant]');
    var id = field && field.value;
    if (!id) return;

    var status = root.querySelector('[data-upsell-status]');
    var t = {
      add: root.getAttribute('data-text-add'),
      adding: root.getAttribute('data-text-adding'),
      added: root.getAttribute('data-text-added'),
      cart: root.getAttribute('data-text-cart'),
      error: root.getAttribute('data-text-error')
    };
    var addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var source = root.getAttribute('data-source') || 'pdp';

    btn.disabled = true;
    btn.textContent = t.adding;
    if (status) { status.classList.remove('is-error'); status.textContent = ''; }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _upsell: source } }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('wowe:upsell:added', { detail: { cart: cart, variantId: Number(id), source: source } }));
        // In the drawer the block is re-rendered with the new cart, so no local feedback is needed.
        var drawerHandled = syncDrawer(cart, source !== 'cart');
        if (source === 'cart' && drawerHandled) return;
        btn.textContent = t.added + ' ✓';
        btn.classList.add('is-done');
        if (status && !drawerHandled) status.innerHTML = '<a href="' + cartUrl + '">' + t.cart + '</a>';
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-done');
          btn.textContent = t.add;
        }, 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = t.add;
        if (status) { status.classList.add('is-error'); status.textContent = t.error; }
      });
  });
})();
